import React, { useMemo } from 'react';
import ViewProcessAssetModalActions from './ViewProcessAssetModalActions';
import { useFormContext } from 'framework/form';
import ProcessAssetFormPreview from 'domain/gpo/processAssets/show/ProcessAssetFormPreview';
import { ProcessAssetsFormType } from 'domain/gpo/processAssets/types';

const ViewProcessAssetContent = ({ closeModal }: { closeModal?: () => void }) => {
  const { data: formData } = useFormContext();
  const { paths } = formData || {};
  const documentPath = useMemo(() => (paths?.length ? paths[0] : ''), [paths]);

  return (
    <>
      <ProcessAssetFormPreview documentPath={documentPath} formData={formData as ProcessAssetsFormType} />

      <ViewProcessAssetModalActions onCloseModal={closeModal!} />
    </>
  );
};

export default ViewProcessAssetContent;
